export default "__VITE_ASSET__w5A0z_A3__"